export const MIN_FILE_SIZE = 1024 // 1KB
export const MAX_FILE_SIZE = 1 * 1024 * 1024 * 1024 // 1GB
export const MAX_FILES = 5000

// Chunk size for uploading images in batches to avoid server overload (EMFILE errors)
export const UPLOAD_CHUNK_SIZE = 100

export const WITH_PRODUCT_CLASS = ['anomaly', 'classification']

export const ALLOWED_IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'bmp']
export const ALLOWED_ZIP_TYPES = ['zip']
export const ALLOWED_TYPES = [...ALLOWED_IMAGE_TYPES, ...ALLOWED_ZIP_TYPES]
export const ALLOWED_MIME_TYPES = [
  'image/bmp',
  'image/png',
  'image/jpeg',
  'application/zip',
  'application/x-zip-compressed',
]

export const NON_ANNOTATED_VALUE = 'non-annotated'
